<template>
  <div class="integral-borrowing">
    <div class="list-search">
      <a-form>
        <a-row>
          <a-col class="search-item" :span="5">
            <a-form-item
              label="商品描述"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-input v-model="tradeName" allow-clear placeholder="请输入商品描述" />
            </a-form-item>
          </a-col>
          <a-col class="search-item" :span="5">
            <a-form-item
              label="分类"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-select
                v-model="commGroup"
                allow-clear
                placeholder="全部"
                show-search
                option-filter-prop="children"
              >
                <a-select-option
                  v-for="item in selectOption"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.title }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col class="search-item" :span="5">
            <a-form-item
              label="发布方"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-select
                v-model="publisher"
                allow-clear
                placeholder="全部"
                show-search
                option-filter-prop="children"
              >
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  回收点发布
                </a-select-option>
                <a-select-option value="1">
                  寄售人发布
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="search-item" :span="5">
            <a-form-item
              label="发布时间"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-date-picker
                v-model="date"
                show-time
                type="date"
                :format="dateFormat"
                :value-format="valueFormat"
                placeholder="发布时间"
                style="width: 100%;"
              />
            </a-form-item>
          </a-col>

          <a-col class="search-item" :span="5">
            <a-form-item
              label="状态"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-select
                v-model="status"
                allow-clear
                placeholder="全部"
                show-search
                option-filter-prop="children"
              >
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  待审核
                </a-select-option>
                <a-select-option value="1">
                  出售中
                </a-select-option>
                <a-select-option value="2">
                  检验不通过
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col class="search-item city" :span="5">
            <a-form-item
              label="区域"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-cascader
                v-model="areaContain"
                :options="options"
                :load-data="loadData"
                :field-names="{
                  label: 'name',
                  value: 'id',
                  children: 'children'
                }"
                placeholder="省市区"
                change-on-select
                @change="onAreaChange"
              />
            </a-form-item>
          </a-col>
          <a-col :span="5" class="search-item">
            <a-form-item
              label="回收点名称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-input v-model="postStationName" allow-clear placeholder="请输入回收点" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="search-item" :span="24" align="right">
            <a-form-item>
              <a-button type="primary" class="mr8" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetTable">
                重置
              </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="pagination"
        :row-key="record => record.id"
        :loading="loading"
        :scroll="{y:'50vh'}"
        class="table-content"
        @change="handleTableChange"
      >
        <template slot="mainPath" slot-scope="mainPath">
          <img :src="mainPath">
        </template>
        <template slot="userInfo" slot-scope="text, record">
          <div class="userInfo">
            <div> 姓名：</div>
            <span>{{ record.userName }}</span>
          </div>
          <div class="userInfo">
            <div>联系方式：</div>
            <span>{{ record.cellPhone }}</span>
          </div>
        </template>
        <template slot="operate" slot-scope="text">
          <a-button type="link" size="small" @click="view(text)">
            查看
          </a-button>
          <a-button type="link" size="small" @click="del(text)">
            删除
          </a-button>
        </template>
      </a-table>
    </div>
    <a-modal
      :visible="delVisible"
      :confirm-loading="delLoading"
      ok-text="确定"
      cancel-text="取消"
      @ok="delOk"
      @cancel="delCancel"
    >
      <div class="dlContent">
        <icon-font type="iconShape" class="dlIcon"></icon-font>
        <span class="dlTitle">提示</span>
        <div class="dlMain">
          是否确定删除此商户？
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { iconFontComponent, getArea, getEstate } from '@/components/mixins/mixins.js'
import { getGoodsList, getGoodsTypeList } from '@/api/commManage'
import { unixToDate } from '@/utils/formatDate'
import { commonData } from '../mixins/mixins'

const columns = [
  {
    title: '商品编号',
    key: 'goodsCode',
    dataIndex: 'goodsCode',
    align: 'center'
  },
  {
    title: '商品图片',
    key: 'mainPath',
    dataIndex: 'mainPath',
    scopedSlots: { customRender: 'mainPath' },
    align: 'center'
  },
  {
    title: '商品描述',
    key: 'introduce',
    dataIndex: 'introduce',
    align: 'center'
  },
  {
    title: '商品分组',
    key: 'title',
    dataIndex: 'title',
    align: 'center'
  },
  {
    title: '出售价',
    key: 'buyPrice',
    dataIndex: 'buyPrice',
    align: 'center'
  },
  {
    title: '发布方信息',
    key: 'userInfo',
    dataIndex: 'userInfo',
    scopedSlots: { customRender: 'userInfo' },
    align: 'center'
  },
  {
    title: '归属回收点',
    key: 'name',
    dataIndex: 'name',
    align: 'center'
  },
  {
    title: '发布时间',
    key: 'createTime',
    dataIndex: 'createTime',
    customRender: (text, record, index) => {
      return unixToDate(text)
    },
    align: 'center'
  },
  { title: '状态',
    key: 'state',
    dataIndex: 'state',
    customRender: (text, record, index) => {
      switch (text) {
        case '0':
          return '待审核'

        case '1':
          return '待审核'
        case '2':
          return '租赁期'
        case '3':
          return '售罄'
        default:
          break
      }
    },
    align: 'center'
  },
  {
    title: '操作',
    key: 'operate',
    width: 150,
    fixed: 'right',
    scopedSlots: { customRender: 'operate' },
    align: 'center'
  }
]
export default {
  mixins: [iconFontComponent, getArea, getEstate, commonData],
  data () {
    return {
      columns

    }
  },
  created () {
    this.getGoodsTypeList()
    this.getGoodsList()
  },

  methods: {
    // 列表
    // 获取分组
    async getGoodsTypeList () {
      const data = {
        type: '0'
      }
      const res = await getGoodsTypeList(data)
      if (res.code === 0) {
        this.selectOption = res.result
        return
      }
      this.commGroup = ''
    },
    // 获取列表
    async getGoodsList () {
      const params = {
        attribute: '0',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        introduce: this.tradeName,
        name: this.postStationName,
        areaId: this.areaContain[2],
        cityId: this.areaContain[1],
        provinceId: this.areaContain[0],
        startTime: this.date,
        goodsTypeId: this.commGroup,
        state: this.status
      }
      this.loading = true
      try {
        const res = await getGoodsList(params)
        if (res.code === 0) {
          this.tableData = res.result.list
          this.pagination.total = res.result.totalCount
        }
      } finally {
        this.loading = false
      }
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.getGoodsList()
    },
    // 查询
    toSearch () {
      this.getGoodsList()
    },
    // 重置
    resetTable () {
      this.page = 1
      this.pageSize = 10
      this.tradeName = ''
      this.areaContain = []
      this.date = ''
      this.commGroup = undefined
      this.publisher = undefined
      this.status = undefined
      this.postStationName = ''
    },

    // 查看
    view (item) {
      this.$router.push({
        path: '/catRecycling/commodityManagement/idleSecondViews',
        query: { id: item.id }
      })
    }

  }
}

</script>
<style lang='less' scoped>
.integral-borrowing{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .list-search{
    width: 100%;
    margin-bottom: 16px;
    background-color: #fff;
    padding: 16px 20px 7px 20px;
    .city{
      margin-right: 10px;
    }
    .mr8{
      margin-right: 10px;
    }
  }
  .table{
    flex: 1;
    background: #fff;
    padding: 16px 20px 7px 20px;
    box-sizing: border-box;
  }
  /deep/ .ant-input,
  /deep/ .ant-col-19,
  /deep/ .ant-form-item-control,
  /deep/ .ant-cascader-picker,
  /deep/ .ant-cascader-picker-label{
    width: 220px;
  }
  .userInfo{
    display: flex;
    >div{
      flex: 1;
      text-align: left;
    }
    >span{
      flex: 1;
      text-align: left;
    }
  }
}
</style>

<style lang="stylus" scoped>
.dlContent
  .dlIcon
    font-size 30px
  .dlTitle
    vertical-align text-bottom
    padding-left: 10px
    font-size: 16px
    color: #333
    font-weight: 500
  .dlMain
    position absolute
    top 64px
    left 64px
    color #666
    font-size 14px
.dlMain
    width: 1
</style>

